<h2 mat-dialog-title>Confirm Action</h2>
<mat-dialog-content>
  <p>Are you sure you want to delete <strong *ngIf="itemName">{{ itemName }}</strong><span *ngIf="!itemName">this
      item</span>?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="warn" (click)="onConfirm()">Delete</button>
</mat-dialog-actions>